// Application level flag setting
export const MOCK_DATA_MODE = false;
